<template>
	<div class="application-page">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation page="security"/>
				</b-col>
				<b-col md="8">
					<h1>Daten & Sicherheit</h1>
					<div class="main-content">
						<div class="tag-sections">
							<section v-if="application">
								<h2>Persönliche Daten</h2>
								<b-row>
									<b-col md="2">
										<span class="font-weight-extra-bold">Name:</span>
									</b-col>
									<b-col md="10">{{ application.name }}</b-col>
								</b-row>
								<b-row class="mt-2">
									<b-col md="2">
										<span class="font-weight-extra-bold">E-Mail:</span>
									</b-col>
									<b-col md="10">{{ application.email }}</b-col>
								</b-row>
								<b-row class="mt-2">
									<b-col md="2">
										<span class="font-weight-extra-bold">Mobilnummer:</span>
									</b-col>
									<b-col md="10">{{ application.phone.formatted }}</b-col>
								</b-row>
								<b-row v-if="application.domicile" class="mt-2">
									<b-col md="2">
										<span class="font-weight-extra-bold">Wohnort:</span>
									</b-col>
									<b-col md="10">{{ application.domicile }}</b-col>
								</b-row>
							</section>
							<section>
								<h2>Sicherheit</h2>
								<Info
									v-if="application"
									:meta="meta"
									:get-security="getSecurity"
									:change-identification="changeIdentification"
									:resend-resend-function="resendResendFunction"
									:resend-change-function="resendChangeFunction"
									:email="application.email"
									:phone="application.phone"
									:with-my-data="false"
									:with-security-title="false"
								/>
							</section>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Navigation from "@/vue/application/profile/Navigation";
import SecurityGet from "@/api/application/security/Get";
import AuthGet from "@/api/auth/Get";
import IdentificationChange from "@/api/application/identification/Change";
import Info from "@/vue/legitimation/security/Info"
import LegitimationResend from "@/api/application/legitimation/Resend";
import LegitimationChange from "@/api/application/legitimation/Change";
import FormGroup from "@/vue/common/form/Group";
import {mapState} from "vuex";

export default {

	components: {
		Info,
		FormGroup,
		Navigation,
	},

	mounted ()
	{
		this.loadApplication();
	},

	data ()
	{
		return {
			application: undefined,
		};
	},

	computed: {
		...mapState('meta', [
			'meta'
		])
	},

	methods: {
		async loadApplication ()
		{
			const response = await new AuthGet().call();

			this.application = response.data.application;
		},
		async getSecurity ()
		{
			const response = await new SecurityGet()
				.call();

			return response.data;
		},
		async changeIdentification (identification)
		{
			const change = new IdentificationChange()
				.setDocumentType(identification.documentType);

			if (identification.identificationId)
			{
				change.setIdentificationId(identification.identificationId)
			}

			if (identification.file)
			{
				change.setFile(identification.file);
			}

			return change.call();
		},
		async resendResendFunction ({type, phoneNumber})
		{
			return new LegitimationResend()
				.setType(type)
				.setPhoneNumber(phoneNumber)
				.call();
		},
		async resendChangeFunction ({type, code})
		{
			return new LegitimationChange()
				.setType(type)
				.setCode(code)
				.call();
		},
	}
}
</script>
